const discoverEN = {
  loading: "Loading…",
  toolbar: {
    filters: "⚙︎ Filters",
    sortBy: "Sort by:",
    showMap: "Show map",
    recommended: "Recommended",
  },
  sort: {
    distance: "Distance",
    highestRated: "Highest rated",
    lowestRated: "Lowest rated",
    recommended: "Recommended"
  },
  title: "Shops",
  subtitle: "What affects the search results?",
  eyebrow: "Discover",
  results: (count) => (count === 1 ? "1 place to book" : `${count} places to book`),
  updating: "Updating results…",
  loadMore: "Load more",
  loadingMore: "Loading more…",
  loadMoreError: "We couldn't load more — tap to try again.",
  showingOf: (shown, total) => `Showing ${shown} of ${total}`,
  reviews: "reviews",
  shop: {
    untitled: "Untitled Shop",
  },
  card: {
    from: "From",
    home: "Home service",
    online: "Online",
    viewShop: "View shop",
    noPhoto: "No photo yet",
  },
  services: {
    book: "Book",
    more: (count) => `+${count} more services`,
  },
  empty: "No shops found",
  emptyHint: "Nothing matches this category near you yet. Try another category, or widen the area on the map.",
  errorLoading: "We couldn't load businesses. Please try again.",
  errorHint: "Check your connection — the listings will load as soon as you're back online.",
  retry: "Try again",
  map: {
    eyebrow: "Explore the map",
    subtitle: "Pick a pin to preview a business, or browse the cards below.",
    listView: "List",
    updating: "Updating results…",
    viewShop: "View shop",
    showOnMap: "Show on map",
    emptyHint: "Try moving the map or zooming out to cover a wider area.",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    results: (count) => (count === 1 ? "1 result" : `${count} results`),
    filters: {
      open: "Filters",
      close: "Close filters",
      title: "Filter results",
      subtitle: "Narrow the map down to what you're looking for.",
      searchLabel: "Search services or businesses",
      searchPlaceholder: "Search a service…",
      clearSearch: "Clear search",
      category: "Category",
      subCategory: "Specialty",
      serviceType: "Service type",
      serviceTypes: { in_shop: "In shop", home: "Home service", online: "Online" },
      rating: "Rating",
      all: "All",
      any: "Any",
      ratingOption: (value) => `${value}+`,
      reset: "Clear filters",
      apply: (count) => (count === 1 ? "Show 1 result" : `Show ${count} results`),
      noResults: "No matches",
      emptyTitle: "Nothing matches those filters",
      emptyHint: "Try clearing a filter, searching a different service, or moving the map.",
    },
  },
};

export default discoverEN;
